/**
 * @fileoverview ReleaseNoteScrollArea — the scrolling wrapper that holds the
 * sequence of ReleaseNoteRow children plus the AllCaughtUpFooter terminator.
 * Foundry uses an inline `height` style so the scroll region fills the
 * dialog body; consumers can override via the `maxHeight` prop.
 *
 * Foundry mapping: `release-notes__release-note-scroll-area__1g6dw2s`
 * (`#release-notes-container`).
 */

import type { CSSProperties, ReactElement, ReactNode } from "react";

interface ReleaseNoteScrollAreaProps {
  children: ReactNode;
  /** CSS height (e.g. "60vh" or 600). Defaults to fluid `60vh`. */
  maxHeight?: CSSProperties["maxHeight"];
  className?: string;
}

export function ReleaseNoteScrollArea({
  children,
  maxHeight = "60vh",
  className,
}: ReleaseNoteScrollAreaProps): ReactElement {
  return (
    <div data-testid="release-note-scroll-area"
      id="release-notes-container"
      className={["bp-release-note-scroll-area", className].filter(Boolean).join(" ")}
      style={{ maxHeight, overflow: "auto" }}
    >
      {children}
    </div>
  );
}
